import { FinesViewComponent } from "./fines-view/fines-view.component";
import { FinesComponent } from "./fines/fines.component";
import { ClaimsViewComponent } from "./claims-view/claims-view.component";
import { AccountStatementViewComponent } from "./account-statement-view/account-statement-view.component";
import { AccountStatementComponent } from "./account-statement/account-statement.component";
import { RentComponent } from "./rent/rent.component";
import { Routes } from "@angular/router";
import { RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { SalesComponent } from "./sales/sales.component";
import { ClaimsComponent } from "./claims/claims.component";
import { FinancialSettingsModule } from "./financial-settings/financial-settings.module";
import { EtaTaxesListingComponent } from "./eta-taxes-listing/eta-taxes-listing.component";
import { ManageEtaTaxesComponent } from "./manage-eta-taxes/manage-eta-taxes.component";
import { EtaClaimsViewComponent } from "./eta-claims-view/eta-claims-view.component";
import { EtaReportsComponent } from "./eta-reports/eta-reports.component";
import { AllClaimsComponent } from "./all-claims/all-claims.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "settings",
    pathMatch: "full",
  },
  {
    path: "sales",
    component: SalesComponent,
  },
  {
    path: "lease",
    component: RentComponent,
  },
  {
    path: "account-statement",
    children: [
      {
        path: "",
        pathMatch: "exact",
        component: AccountStatementComponent,
      },
      {
        path: ":id",
        component: AccountStatementViewComponent,
      },
    ],
  },
  {
    path: "eta-reports",
    children: [
      {
        path: "",
        pathMatch: "exact",
        component: EtaReportsComponent,
      },
    ],
  },
  {
    path: "claims",
    children: [
      {
        path: "",
        pathMatch: "exact",
        component: ClaimsComponent,
      },
      {
        path: ":id",
        component: ClaimsViewComponent,
      },
      {
        path: ":id/eta-view/:eta_claim_id",
        component: EtaClaimsViewComponent,
      },
    ],
  },
  {
    path: "fines",
    children: [
      {
        path: "",
        pathMatch: "exact",
        component: FinesComponent,
      },
      {
        path: ":id",
        component: FinesViewComponent,
      },
    ],
  },
  {
    path: "eta-taxes",
    children: [
      {
        path: "",
        pathMatch: "exact",
        component: EtaTaxesListingComponent,
      },
      {
        path: "add",
        component: ManageEtaTaxesComponent,
      },
      {
        path: ":id/edit",
        component: ManageEtaTaxesComponent,
      },
    ],
  },
  {
    path: "all-claims",
    component: AllClaimsComponent,
  },
  {
    path: "settings",
    loadChildren: () => FinancialSettingsModule,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FinancialRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/financial/financial-routing.module.ts